import LicenseDetailsAccount from './LicenseDetailsAccount';

export default LicenseDetailsAccount;
